export const isInternalLink = (url: string) => {
  const regex = new RegExp('^(ftp|http(s)?|ssh)://', 'i')
  return !regex.test(url)
}
